module.exports = __webpack_public_path__ + "img/companyEle.0a629609.svg";